<template>
    <div class="flex items-center gap-x-4 md:gap-x-3">
        <a
            aria-label="Facebook"
            href="https://www.facebook.com/RoastarBags/"
            target="_blank"
            class="mb-0 rounded p-1.5 text-white hover:bg-white hover:text-grind md:text-lg"
            :class="{ 'border-white md:border': showBorders }"
        >
            <Icon name="facebook" />
        </a>
        <a
            aria-label="Instagram"
            href="https://www.instagram.com/roastar/"
            target="_blank"
            rel="noopener noreferrer"
            class="mb-0 rounded p-1.5 text-white hover:bg-white hover:text-grind md:text-lg"
            :class="{ 'border-white md:border': showBorders }"
        >
            <Icon name="instagram" />
        </a>
        <a
            aria-label="LinkedIn"
            href="https://www.linkedin.com/company/roastar"
            target="_blank"
            class="mb-0 rounded p-1.5 text-white hover:bg-white hover:text-grind md:text-lg"
            :class="{ 'border-white md:border': showBorders }"
        >
            <Icon name="linkedin" />
        </a>
        <a
            aria-label="TikTok"
            href="https://www.tiktok.com/@roastar_coffeebags"
            target="_blank"
            class="mb-0 rounded p-1.5 text-white hover:bg-white hover:text-grind md:text-lg"
            :class="{ 'border-white md:border': showBorders }"
        >
            <Icon name="tiktok" width="19" height="19" />
        </a>
    </div>
</template>

<script setup lang="ts">
defineProps({
    showBorders: {
        type: Boolean,
        default: false,
        required: false,
    },
});
</script>
